<template>
<div class="col-12 text-left">
    <app-nav-bar></app-nav-bar>
    <div class="main-content">
         <h3 class="p-2">
            <small class="text-muted">Customer Complaint Investigation Detail</small>
        </h3>
        <div class="p-2 dropdown-divider"></div>
        <div class="row">
            <div class="form-group col-3">
                <label for="module">Complaint Number</label>
                <input type="text" class="form-control" id="complaint-no" v-model="cci.complaintNo" disabled>
            </div>
            <div class="form-group col-3">
                <label for="module">CCF Log Date</label>
                <!-- <input type="text" class="form-control" id="reported-date" v-model="cci.reportedDate" disabled> -->
                <flat-pickr class="form-control" id="reported-date" v-model="cci.reportedDate" disabled></flat-pickr>
            </div>
            <div class="form-group col-3">
                <label for="module">Distributed to Internal</label>
                <flat-pickr class="form-control" id="reported-date" v-model="cci.distributedToInternal" disabled></flat-pickr>
            </div>
            <div class="form-group col-3">
                <label for="module">Complaint Received Date</label>
                <flat-pickr class="form-control" id="reported-date" v-model="cci.receivedDate" disabled></flat-pickr>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-3">
                <label for="subject">Customer</label>
                <input type="text" class="form-control" id="customer" v-model="cci.customerName" disabled>
            </div>
            <div class="form-group col-3">
                <label for="subject">Brand</label>
                <input type="text" class="form-control" id="brand" v-model="cci.productName" disabled>
            </div>
            <div class="form-group col-3">
                <label for="subject">Product</label>
                <input type="text" class="form-control" id="product" v-model="cci.productName" disabled>
            </div>
            <div class="form-group col-3">
                <label for="subject">Plant</label>
                <input type="text" class="form-control" id="container-no" v-model="cci.plantName" disabled>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-3">
                <label for="module">Address</label>
                <textarea class="form-control" id="address" v-model="cci.address" rows="2" disabled></textarea>
            </div>
            <div class="form-group col-3">
                <label for="module">PIC</label>
                <input type="text" class="form-control" id="pic" v-model="cci.pic" disabled>
            </div>
            <div class="form-group col-3">
                <label for="module">Email</label>
                <input type="text" class="form-control" id="email" v-model="cci.email" disabled>
            </div>
            <div class="form-group col-3">
                <label for="module">Phone</label>
                <input type="text" class="form-control" id="phone" v-model="cci.phone" disabled>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-3">
                <label for="module">BL Date</label>
                <!-- <input type="text" class="form-control" id="bl-date" v-model="cci.blDate" disabled> -->
                <flat-pickr class="form-control" id="bl-date" v-model="cci.blDate" disabled></flat-pickr>
            </div>
            <div class="form-group col-3">
                <label for="module">Dispatch Date</label>
                <!-- <input type="text" class="form-control" id="dispatch-date" v-model="cci.dispatchDate" disabled> -->
                <flat-pickr class="form-control" id="dispatch-date" v-model="cci.dispatchDate" disabled></flat-pickr>
            </div>
            <div class="form-group col-3">
                <label for="module">Container No.</label>
                <input type="text" class="form-control" id="container-no" v-model="cci.containerNo" disabled>
            </div>
            <div class="form-group col-3">
                <label for="subject">Packaging</label>
                <input type="text" class="form-control" id="email" v-model="cci.packagingName" disabled>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-4">
                <label for="module">Discharge Port</label>
                <input type="text" class="form-control" id="discharge-port" v-model="cci.dischargePortName" disabled>
            </div>
            <div class="form-group col-4">
                <label for="module">Country Name</label>
                <input type="text" class="form-control" id="country" v-model="cci.countryName" disabled>
            </div>
            <div class="form-group col-4">
                <label for="module">Incoterms</label>
                <input type="text" class="form-control" id="model-of-delivery" v-model="cci.modelOfDeliveryName" disabled>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-4">
                <label for="module">Non Conformance Type</label>
                <input type="text" class="form-control" id="conformance-type" v-model="cci.conformanceTypeName" disabled>
            </div>
            <div class="form-group col-4">
                <label for="module">Complaint Media</label>
                <input type="text" class="form-control" id="complaint-media" v-model="cci.complaintMediaName" disabled>
            </div>
            <div class="form-group col-4">
                <label for="module">Enclosed</label>
                <input type="text" class="form-control" id="enclosed" v-model="cci.enclosedName" disabled>
            </div>
        </div>
         <div class="row">
            <div class="form-group col-12">
                <label for="module">Description</label>
                <textarea class="form-control" id="description" v-model="cci.description" rows="3" disabled></textarea>
            </div>
        </div>
        <div class="row">
            <div v-if="this.$route.query.id !== undefined && this.cci.ccSalesAttachment !== ''" class="form-group col-12">
               <a :href="this.cci.ccSalesAttachment" class="badge badge-primary">Download Attachment from Sales</a>
            </div>
            <div v-if="this.$route.query.id !== undefined && this.cci.ccSalesAttachment === ''" class="form-group col-12">
               <a style="color: white;" class="badge badge-secondary">No Attachment from Sales</a>
            </div>
        </div>
        Customer Complaint Detail
        <app-datatable :type="'view'" :newData="newCustomerComplaintDetail" :elements="dtElementsDetail" :collections="cci.customerComplaintDetail"></app-datatable>
        <br />
        <div class="input-container">
            <app-datatable :type="'input'" :newData="newDetail" :elements="dtElements" :collections="cci.detail"></app-datatable>
        </div>
        <br />
        <button type="button" class="btn btn-outline-success" @click="save">Save <i class="far fa-save"></i></button>
        <button type="button" class="btn btn-outline-warning" @click="cancel" style="margin-left: 20px;">Cancel <i class="far fa-window-close"></i></button>
        <br /><br />
    </div>
</div>
</template>

<script>
import api from '../../services/api'
import { customerComplaintInvestigation, customerComplaintDetail, customerComplaintInvestigationDetail } from '../../models/customerComplaintInvestigation'
import AppLookupField from '../../components/AppLookupField.vue'
import AppDatePicker from '../../components/AppDatePicker.vue'
import AppDropdown from '../../components/AppDropdown.vue'
import AppNavBar from '../../components/AppNavbar.vue'
import AppDatatable from '../../components/AppDatatable.vue'

export default {
    components: {
        AppLookupField, AppDatePicker, AppNavBar, AppDropdown, AppDatatable
    },
    data() {
        return {
          cci: {...customerComplaintInvestigation, customerComplaintDetail: [], detail: []},
          newDetail: customerComplaintInvestigationDetail,
          newCustomerComplaintDetail: customerComplaintDetail,
          dtElementsDetail: [
                {
                    title: 'PO',
                    column: 'po',
                    type: 'text',
                    width: 6,
                },
                {
                    title: 'SO',
                    column: 'so',
                    type: 'text',
                    width: 6,
                },
                {
                    title: 'Batch',
                    column: 'batch',
                    type: 'text',
                    width: 6,
                },
                {
                    title: 'Qty',
                    column: 'qty',
                    type: 'text',
                    width: 6,
                },
            ],
          dtElements: [
              {
                  title: 'Question',
                  column: 'question',
                  type: 'text',
                  width: 6,
              },
              {
                  title: 'Responder',
                  column: 'responder',
                  type: 'lookup',
                  width: 6,
                  lookup: {
                      id: 'member',
                      title: 'Member Data',
                      type: 'table',
                      apiUrl: 'member-management/lookup',
                      filter: ['firstName', 'lastName', 'email'],
                      fields: [
                          {
                              placeholder: 'Responder',
                              width: 5,
                              column: 'responder'
                          }
                      ],
                      dtElements: [
                          {
                              title: 'First Name',
                              column: 'firstName'
                          },
                          {
                              title: 'Last Name',
                              column: 'lastName'
                          },
                          {
                              title: 'Email',
                              column: 'email'
                          },
                      ],
                      affectedField: [
                          {
                              from: 'id',
                              to: 'memberId'
                          },
                          {
                              from: 'firstName',
                              to: 'responder'
                          },
                          {
                              from: 'email',
                              to: 'email'
                          },
                      ]
                  },
                  disable: true,
              },
              {
                  title: 'Email',
                  column: 'email',
                  type: 'text',
                  width: 4,
                  disable: true,
              },
              {
                  title: 'Answer',
                  column: 'answer',
                  type: 'text',
                  width: 4,
                  disable: true,
              },
              {
                  title: 'Answered At',
                  column: 'answeredAt',
                  type: 'date',
                  width: 4,
                  disable: true,
              },
          ]
        }
    },
    async created() {
        const isLogin = localStorage.getItem('ucf_token')
        if(isLogin) {
            if(this.$route.query.id !== undefined) {
                const cciApi = api('customer-complaint-investigation')
                this.cci = await cciApi.getWithParams(this.$route.query.id)
            }   
        } else {
            this.$router.push({ name: 'login' })
        }
    },
    methods: {
        async save() {
            const cciApi = api('customer-complaint-investigation')
            if(this.$route.query.id !== undefined) {
                await cciApi.update(this.cci, this.$route.query.id)
            }
            this.$router.push({ name: 'customerComplaintInvestigationAnswerSubmitted' })
        },
        cancel() {
            this.$router.go(-1)
        },
        finishLookup(data) {
            const currentCcs = this.cci
            this.cci = {
                ...currentCcs,
                ...data
            }
        }
    }
}
</script>